export interface Job {
  company: string;
  duration: string;
  role: string;
  isCurrent: boolean;
  startYear: string;
  bullets: string[];
}

export const jobs: Job[] = [
  {
    company: 'PT Dkatalis Digital Lab',
    duration: 'Feb 2025 - Present',
    role: 'Staff Engineer',
    isCurrent: true,
    startYear: '2025',
    bullets: [
      'Owned end-to-end delivery of a new payroll system — now live in production and adopted by customers.',
      'Architected the database layer for a Google Drive–style access management system, integrating Ory for auth and authorisation.',
      'Reduced backend test duplication and improved coverage by introducing parameterised testing with JUnit5.',
      'Improved engineer onboarding clarity and bootstrapped a knowledge-sharing session that grew into a recurring tribe-level event.',
    ],
  },
  {
    company: 'Govtech Edu Indonesia',
    duration: 'Oct 2022 - Dec 2024',
    role: 'Engineering Manager / Tech Lead (Hands-On)',
    isCurrent: false,
    startYear: '2022',
    bullets: [
      'Led a re-architecture from PostgreSQL to BigQuery and implemented a message broker, improving data quality from 80% to 92% while reducing latency.',
      'Led the migration of 500+ databases into a unified system, streamlining 120+ annually created databases into a centralised structure.',
      'Designed and developed microservices for a Self-serve Data Quality Management system with BigQuery integration.',
      'Improved team delivery by shifting the sprint cycle from 2 weeks to 1 week, leading to quicker project delivery and better collaboration.',
    ],
  },
  {
    company: 'Bukalapak.com',
    duration: 'Apr 2021 - Oct 2022',
    role: 'Engineering Manager (Hands-On)',
    isCurrent: false,
    startYear: '2021',
    bullets: [
      'Led a team of 8 engineers managing the marketplace seller platform at 100–300 RPS using Ruby, Golang, and GCP.',
      'Led the ClickHouse project, reducing MySQL query times from constant timeouts to under 1 second.',
      'Optimised resource usage to 40–60% CPU/memory range, improving overall system performance by 20%.',
    ],
  },
  {
    company: 'Bukalapak.com',
    duration: 'July 2019 - Apr 2021',
    role: 'Technical Lead (Hands-On)',
    isCurrent: false,
    startYear: '2019',
    bullets: [
      'Led a task force of 6 senior engineers to transition seller membership from subscription-based to fee-based within one week with zero incidents.',
      'Mentored 3 junior engineers — all three advanced to mid-level within one year.',
      'Led the Facebook Ads Discrepancies project, reducing data mismatches for 400,000 products from 70% to 20% and driving a 15–18% revenue increase.',
    ],
  },
  {
    company: 'Bukalapak.com',
    duration: 'Mar 2017 - July 2019',
    role: 'Software Engineer',
    isCurrent: false,
    startYear: '2017',
    bullets: [
      'Achieved a 99% SLO by implementing proper monitoring, alerting, and testing procedures.',
      'Created 3–5 microservices to replace a monolithic service, improving deployment speed, scalability, and fault isolation.',
    ],
  },
  {
    company: 'Liberty Jaya',
    duration: 'Apr 2015 - Mar 2017',
    role: 'Software Developer',
    isCurrent: false,
    startYear: '2015',
    bullets: [
      'Developed and maintained internal tools to support business operations, improving workflow efficiency and automation.',
    ],
  },
];
